import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { TagCountTag, TagPicker } from '../tags';
import { useAmplitude, useCurrentUser, useLinkTag, useSonarObjectReference, useUnlinkTag } from '@hooks';

export interface SonarTagManagerProps {
	sonarObjectId: number;
}

export const SonarTagManager: React.FC<SonarTagManagerProps> = ({ sonarObjectId }) => {
	const logEvent = useAmplitude();
	const { isReadOnly } = useCurrentUser();

	const { request: requestLink } = useLinkTag();
	const { request: requestUnlink } = useUnlinkTag();

	const selectedTagIds = useSonarObjectReference(sonarObjectId)?.tagIds ?? [];

	const linkTag = useCallback(
		(tagId: number) => {
			requestLink({
				sonarObjectIds: [ sonarObjectId ],
				sonarObjectTagId: tagId
			});

			logEvent(AMPLITUDE_EVENT.TAG_LINKED, {
				objectType: SonarObjectType.SalesforceField
			});
		},
		[ logEvent, requestLink, sonarObjectId ]
	);

	const unlinkTag = useCallback(
		(tagId: number) => {
			requestUnlink({
				sonarObjectId,
				sonarObjectTagId: tagId
			});

			logEvent(AMPLITUDE_EVENT.TAG_UNLINKED, {
				objectType: SonarObjectType.SalesforceField
			});
		},
		[ logEvent, requestUnlink, sonarObjectId ]
	);

	if (isReadOnly) {
		return <TagCountTag count={ selectedTagIds.length } />;
	}

	return (
		<TagPicker
			onDeselect={ unlinkTag }
			onSelect={ linkTag }
			selectedTagIds={ selectedTagIds }>
			<TagCountTag count={ selectedTagIds.length } />
		</TagPicker>
	);
};
